import { useContext, useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { GlobalContext } from "../GlobalContext";

export default function ClubOverview() {
  const navigate = useNavigate();

  const { cid } = useParams();

  const { alert, setLoading } = useContext(GlobalContext);

  const [colors, setColors] = useState([]);

  const [details, setDetails] = useState({
    color: "",
    sponsor1name: "",
    // sponsor1file: "",
    sponsor2name: "",
    // sponsor2file: "",
  });

  useEffect(() => {
    setLoading(true);
    (async () => {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/club/color/${cid}`, {
        method: "GET",
        headers: {
          Authorization: localStorage.getItem("auth"),
        },
      });
      const { data, error } = await res.json();
      if (res.ok) {
        const { colors, color } = data;
        if (color) {
          console.log(color);
          navigate("/dashboard");
          alert({ type: "success", title: "Success !", text: "Club Already Submitted" });
        } else setColors(colors);
      } else alert({ type: "warning", title: "Warning !", text: error });
    })()
      .catch((error) => alert({ type: "danger", title: "Error !", text: error.message }))
      .finally(() => setLoading(false));
  }, [alert, cid, navigate, setLoading]);

  const submitClub = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/club/submit`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("auth"),
        },
        body: JSON.stringify({ ...details, cid }),
      });
      const { data, error } = await res.json();
      if (res.ok) {
        navigate("/dashboard");
        alert({ type: "success", title: "Success !", text: data });
      } else {
        alert({ type: "warning", title: "Warning !", text: error });
      }
    } catch (error) {
      alert({ type: "danger", title: "Error !", text: error.message });
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = async (file, key) => {
    if (!file) return;
    setLoading(true);
    // try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/asset`, {
      method: "POST",
      headers: {
        Authorization: localStorage.getItem("auth"),
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ name: file.name, mime: file.type, size: file.size }),
    });
    const { data, error } = await res.json();
    if (res.ok) {
      console.log(data);
      const { url, fields, _id } = data;
      const fd = new FormData();
      for (const [key, val] of Object.entries(fields)) fd.append(key, val);
      fd.append("file", file);
      const ress = await fetch(url, { method: "POST", body: fd });
      if (!ress.ok) throw new Error("File Storage Unavailable");
      setDetails((d) => ({ ...d, [key]: _id }));
    } else {
      throw new Error(error);
    }
    // } catch (error) {
    //   e.target.value = "";
    //   alert({ type: "warning", title: "Warning !", text: error.message });
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <div className="page-body">
      <div className="container-xl d-flex flex-column justify-content-center">
        {/*Boolean(selectedColor) ? (
          <div className="card">
            <div className="card-header flex-column align-center">
              <h2 className="h2">Club Overview</h2>
            </div>
            <div className="card-body">
              <div className="mb-3">
                <label className="form-label">Selected Club Color</label>
                <div className="row g-2">
                  <div className="col-auto">
                    <label className="form-colorinput">
                      <span className="form-colorinput-color" style={{ backgroundColor: selectedColor }} />
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (*/}
        <form onSubmit={submitClub} className="card">
          <div className="card-header flex-column align-center">
            <h2 className="h2">Club Overview</h2>
          </div>
          <div className="card-body">
            <div className="mb-3">
              <label className="form-label">Select Available Club Color</label>
              <div className="row g-2">
                {colors.map((cls) => (
                  <div key={cls._id} className="col-auto">
                    <label className="form-colorinput">
                      <input
                        name="color"
                        type="radio"
                        value={cls._id}
                        className="form-colorinput-input"
                        checked={details.color === cls._id}
                        onChange={(e) => setDetails((d) => ({ ...d, color: e.target.value }))}
                        required
                      />
                      <span className="form-colorinput-color" style={{ backgroundColor: cls.code }} />
                    </label>
                  </div>
                ))}
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">Sponsor Name 1</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name"
                value={details.sponsor1name}
                onChange={(e) => setDetails((d) => ({ ...d, sponsor1name: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <div className="form-label">Sponsor Logo 1</div>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                onChange={(e) =>
                  handleFileUpload(e.target.files[0], "sponsor1file")
                    .catch((error) => {
                      e.target.value = "";
                      alert({ type: "warning", title: "Warning !", text: error.message });
                    })
                    .finally(() => setLoading(false))
                }
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Sponsor Name 2</label>
              <input
                type="text"
                className="form-control"
                placeholder="Enter name"
                value={details.sponsor2name}
                onChange={(e) => setDetails((d) => ({ ...d, sponsor2name: e.target.value }))}
              />
            </div>
            <div className="mb-3">
              <div className="form-label">Sponsor Logo 2</div>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                onChange={(e) =>
                  handleFileUpload(e.target.files[0], "sponsor2file")
                    .catch((error) => {
                      e.target.value = "";
                      alert({ type: "warning", title: "Warning !", text: error.message });
                    })
                    .finally(() => setLoading(false))
                }
              />
            </div>
          </div>
          <div className="card-footer text-center">
            <button type="submit" className="btn btn-primary mx-1">
              Submit Club
            </button>
          </div>
          <ul className="card-footer">
            <li>Please submit all the Teams which are in pending status or delete the same.</li>
            <li>Once all teams are submitted then only you can submit the club.</li>
          </ul>
        </form>
        {/*)*/}
      </div>
    </div>
  );
}
